/**
 * Copyright (c) 2010-2023 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { MeasureEvent } from '../../../interaction/measure.interaction';
import { Observable, Subject } from 'rxjs';
import { filter, takeUntil, tap } from 'rxjs/operators';
import { MatCard } from '@angular/material/card';
import { LayoutDirective, LayoutAlignDirective } from '@ngbracket/ngx-layout/flex';
import { MatIcon } from '@angular/material/icon';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'dash-gis-measure-dialog',
    templateUrl: './measure-dialog.component.html',
    styleUrls: ['./measure-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatCard, LayoutDirective, LayoutAlignDirective, MatIcon, AsyncPipe],
})
export class MeasureDialogComponent implements OnInit, OnDestroy {
    private dispose$ = new Subject<void>();

    constructor(
        public dialogRef: DialogRef<MeasureDialogComponent>,
        @Inject(DIALOG_DATA) public data$: Observable<MeasureEvent>,
        private cdr: ChangeDetectorRef
    ) {}

    ngOnInit(): void {
        this.data$
            .pipe(
                filter((event) => !!(event && event.measurement)),
                tap(() => {
                    this.cdr.markForCheck();
                }),
                takeUntil(this.dispose$)
            )
            .subscribe();
    }

    ngOnDestroy() {
        this.dispose$.next();
    }

    close() {
        this.dialogRef.close();
    }
}
